<template>
    <div>
        <breadcrumb :routerList="[{title:'流程审批历史'}]"/>
        <div class="h-content">
            <div class="h-row" style="background: #fff;margin-left: 0rem; margin-right: 0rem;">
                <div class="h-rowIn" style="width: 100%;">
                    <div id="graphContainer"
                         ref="graphContainer">

                    </div>
                </div>

                <div    v-if="showTaskList"
                     class="showTaskListClass"
                     :style="{
                              top:showTaskListPosition.top,
                              left:showTaskListPosition.left
                              }">
                    <table>
                        <thead>
                            <tr>
                                <th width="80px">待办人</th>
                                <th width="110px">开始时间</th>
                                <th width="110px">结束时间</th>
                                <th width="110px">操作</th>
                                <th width="60px">状态</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in nodetasklist">
                                <td>{{item.dbrname}}</td>
                                <td>{{item.begindate}}</td>
                                <td>{{item.enddate}}</td>
                                <td>{{item.shpopt}}</td>
                                <td>{{item.status|taskstatus}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="h-row h-mrt0" style="background: #fff;margin-left: 0rem; margin-right: 0rem;">
                    <div class="h-rowIn">
                        <div class="h-rowBox">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>流程审批历史</h1>
                                    </div>
                                    <div class="outTimeline">
                                        <el-timeline>
                                            <el-timeline-item  v-for="o1,i1 in hislist" :timestamp="o1.name" placement="top" color='#2589f3'>
                                                <div v-if="showBlflag(o1,1)" class="timeTip">*须全部人员审批</div>
                                                <div v-else-if="showBlflag(o1,2)" class="timeTip">*至少一个人审批</div>

                                                <el-card v-for="o,i in o1.tasklist" class="box-card">
                                                    <div class="eve_half">
                                                        <span>经办时间：</span><span>{{o.begindate}}</span>
                                                    </div>
                                                    <div class="eve_half">
                                                        <span>办理时间：</span>
                                                        <span v-if="o.status==0" class="corlorOrange">未办理</span>
                                                        <span v-else>{{o.enddate}}</span>
                                                    </div>
                                                    <div class="eve_half">
                                                        <span>经办人：</span><span>{{o.dbrname}}[{{o.dbrcode}}]</span>
                                                    </div>
                                                    <div class="eve_half">
                                                        <span>审批操作：</span><span>{{o.shpopt}}</span>
                                                    </div>
                                                    <div class="eve_all">
                                                        <span>审批意见：</span><span>{{o.shpyj}}</span>
                                                    </div>
                                                    <el-button v-if="o.status==0" class="h-btn h-formBtn h-mr20 cuban btnColor">
                                                        催办
                                                    </el-button>
                                                </el-card>

                                            </el-timeline-item>

                                        </el-timeline>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import {genGraph} from './graph/Graph';

    import mxgraph from './graph/index';
    import _ from 'lodash';

    const {
        mxCellMarker,
        mxCellTracker,
        mxUtils,
        mxRectangle,
        mxEvent,
        mxWindow,
        mxConstants,
    } = mxgraph;


    function setStyle(state, status)
    {
        if (status){
            state.style[mxConstants.STYLE_FILLCOLOR] = '#05FF05';
        }else{
            state.style[mxConstants.STYLE_FILLCOLOR] = '#ff130a';
        }
        state.shape.apply(state);
        state.shape.redraw();
    };
    export default {
        filters: {
            taskstatus: function (value) {
                return value==1?"已完成":"未处理"
            }
        },
        data() {
            return {
                showTaskList:false,
                showTaskListPosition:{
                    top: '0',
                    left: '0',},
                nodetasklist:[],
                graph:null,
                taskid: null,
                instid: null,
                hislist: [],
                inst: {},

            //  展示审批流
                tabIndex: 1,
                hislist:[],
                hismm:[],
            };
        },
        created() {
            this.instid = this.$route.query.instid;
        },
        mounted() {
            this.init();
            this.loadlist();
        },
        methods: {
            init() {
                ss.proinstservice.getByid(this.instid).then(rd => {
                    this.inst = rd.obj;
                    ss.prodefservice.selectById(this.inst.defid).then(rd => {
                        this.reshowFlow(rd);
                    })
                })
            },
            reshowFlow(rd){
                const container = this.$refs.graphContainer
                this.graph = genGraph(container)
                this.graph.importModelXML(rd.obj.prodefxml);
                this.graph.setEnabled(false);
                //设置导航图的任务节点的鼠标与移入移出效果
                new mxCellTracker(this.graph,"#6482b9");
                var vm  = this;
                var vmgraph = this.graph;
                this.graph.addMouseListener({
                    mouseMove(sender,me){
                        var cell = me.getCell()
                        if(cell && vmgraph.getModel().isVertex(cell) && cell.flag==20){
                            vm.showTaskListPosition.left = me.evt.x + 'px';
                            vm.showTaskListPosition.top = me.evt.y + 'px';
                            this.nodetasklist = [];
                            var rt = vm.setTaskLsit(cell.id)
                            vm.showTaskList = rt;
                        }else{
                            this.nodetasklist = [];
                            vm.showTaskList = false;
                            return ;
                        }
                    },
                })

                var allcells = this.graph.getModel().cells;
                console.log(allcells)
                //开始节点// 结束节点
                for(var i in allcells){
                    var se = allcells[i];
                    if(se.flag==10){
                        setStyle(this.graph.view.getState(se),1);
                    }else if(se.flag==100){
                        if(this.inst.status == '已结束'){
                            setStyle(this.graph.view.getState(se),1);
                        }
                    }
                }
                //根据所有的task，设置node的border的style
                var donetask = _.filter(this.hislist,{status:1});
                var undonetask = _.filter(this.hislist,{status:0});
                for(var i=0;i<donetask.length;i++){
                    var obj = donetask[i];
                    var cell = allcells[obj.nodeid];
                    setStyle(this.graph.view.getState(cell),obj.status)
                }
                for(var i=0;i<undonetask.length;i++){
                    var obj = undonetask[i];
                    var cell = allcells[obj.nodeid];
                    setStyle(this.graph.view.getState(cell),obj.status)
                }

            },
            //根据id，获取task数据
            setTaskLsit(id){
                var list = _.find(this.hislist,{nodeid:id});
                if(list && list.tasklist){
                    this.nodetasklist = list.tasklist
                    return true;
                }
                return false;
            },

            showBlflag(o,f){
                if(o.tasklist && o.tasklist.length<=1){
                    return false;
                }
                if(o.status==0 && o.binglianflag == f){
                    return true;
                }
                return false;
            },
            tabchange(i) {
                this.tabIndex = i;
            },
            loadlist(){
                ss.taskservice.listHistoryByInstid(this.instid).then(rd => {
                    this.hislist = rd.history;
                })
            }
        }
    }
</script>

<style scoped>
    #graphContainer {
        position: relative;
        overflow: hidden;
        width: 100%;
        min-height: 150px;
        padding-bottom: 20px;
        background: url('../../assets/images/flow/grid.gif');;
        border-radius: 4px;
    }
    .h-content {
        padding: 0rem 0.38rem 0 0.32rem;
    }
    .h-row .h-rowIn {
      padding: 0px !important;
    }
    .showTaskListClass {
        width:400px;
        border:1px solid #ccc;
        position: fixed;
        color:#333;
        font-size: 12px;
        z-index: 9999;
        background-color: rgba(255,255,255,0.8);
        border: 1px solid #c2c2c2;
        border-radius: 5px;
        padding: 12px;
    }
    .showTaskListClass  table {
          border-collapse: collapse;
          margin: 0 auto;
          text-align: center;
      }
    .showTaskListClass  table thead th{
        background-color: #57aefe;
        text-align: center;
        color:#fff;
    }
    .showTaskListClass table td, table th
    {
        border: 1px solid #cad9ea;
        color: #666;
        height: 30px;
    }
    .showTaskListClass table tr:nth-child(odd)
    {
        background: #fff;
    }
    .showTaskListClass table tr:nth-child(even)
    {
        background: #F5FAFA;
    }
</style>
<style scoped="scoped" lang="scss">
    .outTimeline {
        background-color: #fcfcfc;
        border: 1px solid #dedede;
        border-radius: 10px;
        padding: 40px 0 10px 200px;
    }

    .box-card {
        width: 714px;
        font-size: 18px;
        color: #494949;
        margin-bottom: 20px;
        position: relative;
    }

    .eve_half {
        width: 50%;
        float: left;
        margin-bottom: 10px;
    }

    .eve_all {
        width: 100%;
    }

    .corlorOrange {
        color: #e64a19;
    }

    .timeTip {
        font-size: 14px;
        color: #e64a19;
        position: absolute;
        left: -130px;
        width: 120px;
    }

    .cuban {
        position: absolute;
        right: -100px;
        top: 36px;
    }

    .btnColor {
        background-color: #59b0ff;
        border: none;
    }

    .conimgList {
        display: flex;
        width: 100%;
        .ConImg {
            width: 99px;
            height: 99px;
            border: 1px solid #f2f2f2;
            margin-right: 10px;
            position: relative;
            .circleBages {
                width: 25px;
                height: 25px;
                border-radius: 50%;
                background-color: #16b220;
                color: white;
                text-align: center;
                line-height: 25px;
                font-size: 10px;
                position: absolute;
                right: 0;
                top: 0;
            }
            img {
                height: 100%;
                width: 100%;
                margin-right: 10px;
            }
        }
    }

    .outerCon {
        display: flex;
        justify-content: flex-start;
        border-bottom: 1px solid #dae0f0;
        width: 100%;
        margin-bottom: 30px;
        .tabBtn {
            background-color: #f0f5fb;
            padding: 10px;
            border: 1px solid #dae0f0;
            margin-right: 10px;
            color: #282c2f;
            cursor: pointer;
        }
        .tabBtnAc {
            color: white;
            background-color: #2785e7;
        }
    }

    /*--------------- 审批样式 ------------------*/

    .rightstep {
        width: 170px;
        height: 5px;
        background-image: linear-gradient(-90deg,
                #0056a4 0%,
                #3291fd 100%),
        linear-gradient(
                        #0e75e9,
                        #0e75e9);
        background-blend-mode: normal,
        normal;
        position: relative;
    }

    .readiu {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        border: 3px solid #0056a4;
        position: relative;
        left: 74px;
        top: -12px;
        background-color: white;
    }

    .fukaun {
        width: 170px;
        height: 5px;
        background-image: linear-gradient(-90deg,
                #e2e5e7 0%,
                #e2e5e7 100%),
        linear-gradient(
                        #e2e5e7,
                        #e2e5e7);
        background-blend-mode: normal,
        normal;
        position: relative;
    }

    .color {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        border: 3px solid #c7c8ca;
        position: relative;
        left: 74px;
        top: -12px;
        background-color: white;
    }

    .fuwu {
        width: 48px;
        height: 50px;
        background-color: white;
        border-radius: 4px;
        border: solid 2px #c7c8ca;
        font-size: 15px;

        text-align: center;
        /* padding: 16px 0; */
        position: relative;
        flex-shrink: 0;
        margin: 20px 0;
    }

    .stepBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        margin-left: 3%;
    }

    .leftstep {
        width: 48px;
        height: 50px;
        background-color: #fcfcfc;
        border-radius: 4px;
        border: solid 2px #0e75e9;
        font-size: 15px;
        color: #0e75e9;
        text-align: center;
        /* padding: 16px 0; */
        position: relative;
        flex-shrink: 0;
        margin: 20px 0;

    }

    img {
        width: 18px;
        padding: 3px 0;
        margin-left: 0.035rem;
        /* margin-top: -3px; */
        color: block;
    }

    .name {
        margin-left: 9px;
        /* margin-top: -24px; */
    }

    .fanhui {
        padding: 15px 35px;
        color: white;
        background-color: #006aca;
    }

    .F-H {
        margin-top: 15px;
        margin-left: 8rem;
    }

    .stepBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        margin-left: 3%;
    }

    .stepBox .step {
        width: 16%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .stepBox .step:last-child {
        width: 100px;
    }

    .stepBox .step .leftstep {
        width: 48px;
        height: 50px;
        background-color: #fcfcfc;
        border-radius: 4px;
        border: solid 2px #0e75e9;
        font-size: 15px;
        color: #0e75e9;
        text-align: center;
        /* padding: 16px 0; */
        position: relative;
        flex-shrink: 0;
        margin: 20px 0;

    }

    .stepBox .step .leftstep .times {
        width: 140px;
        position: absolute;
        top: 120px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #595959;
    }

    .stepBox .step .rightstep {
        width: 170px;
        height: 5px;
        background-image: linear-gradient(-90deg,
                #0056a4 0%,
                #3291fd 100%),
        linear-gradient(
                        #0e75e9,
                        #0e75e9);
        background-blend-mode: normal,
        normal;
        position: relative;
    }

    .stepBox .step .rightstep .circle {
        width: 23px;
        height: 23px;
        background-color: #fcfcfc;
        border: 2px solid #3291fd;
        overflow: hidden;
        border-radius: 50%;
        position: absolute;
        top: -9px;
        left: 63%;
        transform: translateX(-25px);
    }

    .stepBox .step .rightstep .circle img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 15px;
    }

    .make {
        width: 110px;
        padding-left: 17px;
    }

    .jiazhi {
        width: 100px;
        padding-left: 20px;
    }

    .zhangqi {
        width: 168px;
        padding-left: 10px;
    }

    .yuan, .zhanyong, .money, .xianjin, .dingdan {
        width: 120px;
        padding-left: 20px;
    }

    .renminbi {
        width: 90px;
        padding-left: 20px;
    }

    .bizhong {
        width: 72px;
        padding-left: 20px;

    }

    .renminbi,
    .money,
    .yuan,
    .zhangqi,
    .make {
        background-color: white;
        font-size: 10px;
    }

    .bizhong,
    .dingdan,
    .xianjin,
    .zhanyong,
    .jiazhi {
        background-color: #ebf5ff;
        font-size: 10px;
    }

    .bizhong,
    .renminbi,
    .dingdan,
    .money,
    .xianjin,
    .yuan,
    .zhangqi,
    .zhanyong,
    .jiazhi,
    .make {
        font-size: 15px;
        color: black;
        padding: 20px 0;
        padding-left: 18px;
        border-bottom: 1px solid rgb(223, 222, 222);
        border-right: 1px solid rgb(236, 236, 236);
    }

    .jieguo {
        margin-top: 12px;
        display: flex;
        margin: 0 20px;

    }

    /*span {*/
    /*    color: white;*/
    /*    position: relative;*/
    /*    top: -12px;*/
    /*    left: 20px;*/
    /*    font-size: 14px;*/
    /*}*/

    .newProject {
        margin: 0 20px;
        background-color: rgb(94, 182, 233);
    }

    .h-crumbOut {
        margin-bottom: 20px;
    }

    .h-piece {
        margin: 20px;
    }

    .h1 {
        margin-left: 27px;
    }

    .bbbb {
        padding-top: 5px;
        margin: 10px 20px 0 20px;
    }

    .neixiao .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
</style>
<style>
    .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .h-formbLine .extraItem .el-form-item__label {
        width: 9.7%;
        text-align: right;
    }

    .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .h-formbLine .h-elformWrap-2 {
        width: 33.333% !important;
        padding-right: 0.5rem
    }

    .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }

    .outTimeline .el-card, .el-message {
        overflow: visible;
    }

    .outTimeline .el-timeline-item__timestamp.is-top {
        margin-left: -130px;
        color: #0e75e9;
        font-size: 18px;
    }
</style>
